/**
 * @typedef {Object} DefaultFormPopupField
 * @property {String} type
 * @property {String} label
 * @property {String} code
 * @property {String} classModifier
 * @property {String[]} classes
 * @property {Boolean} required
 */

/**
 * @typedef {Object} DefaultFormPopupData
 * @property {Number} formId form ID
 * @property {String} title Popup title
 * @property {String} textBefore Text before form
 * @property {String} submitLabel Submit button caption
 * @property {DefaultFormPopupField[]} fields
 */

export default class DefaultFormPopup {
    /**
     * @param {DefaultFormPopupData} data
     */
    constructor(data) {
        this.data = data;
        this.state = 'fill';
        this.prefix = 'wholesale-request';

        this.$popup = $(this.popupTemplate());
        $('body').append(this.$popup);

        this.$popup.modal('show');

        this.$popup.find(`.default-form-popup__agreement`).on('change', this.toggleSubmit.bind(this));
        this.$popup.find(`form`).on('submit', this.onSubmit.bind(this));
        //this.$popup.find(`.default-form-popup__submit`).on('click', this.onSubmitClick.bind(this));
        this.$popup.on('hidden.bs.modal', this.onClose.bind(this));
    }

    popupTemplate() {
        return `
            <div class="modal fade simple-modal default-form-popup" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">${this.data.title || 'Заявка'}</div>
                            <div class="simple-modal__subtitle">
                                ${this.data.textBefore}
                            </div>

                            <form>
                                <div class="default-form-popup__form">
                                    <input type="hidden" name="_key" value="a20O1BzsfoU" />
                                    ${this.data.fields.map(item => this.renderField(item)).join('')}
                                    
                                    <div class="form-group">
                                        <input type="checkbox" class="default-form-popup__agreement" id="default-form-popup-agreement" />
                                        <label class="mr-1" for="default-form-popup-agreement">Я даю согласие на обработку персональных данных</label>
                                    </div>
                                    
                                    <div class="default-form-popup__success hidden">Спасибо, мы скоро с вами свяжемся</div>
                                </div>

                                <div>
                                    <div class="default-form-popup__btn-block">
                                        <button class="gui-button gui-button--disabled default-form-popup__submit" disabled type="submit">${this.data.submitLabel || 'Отправить'}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * @param {DefaultFormPopupField} field
     * @returns {string}
     */
    renderField(field) {
        switch (field.type) {
            case 'name':
                field = {
                    label: 'Ваше ФИО',
                    code: 'name',
                    classModifier: 'name',
                    required: true,
                    ...field,
                    type: 'input',
                };
                break;

            case 'phone':
                field = {
                    label: 'Ваш номер телефона',
                    code: 'phone',
                    classModifier: 'phone',
                    required: true,
                    ...field,
                    type: 'input',
                };
                break;

            case 'email':
                field = {
                    label: 'Ваш email',
                    code: 'email',
                    classModifier: 'email',
                    required: true,
                    ...field,
                    type: 'input',
                };
                break;
        }

        let type = field.type || 'input';
        let label = field.label;
        let code = field.code;
        let classes = ['lb-input', 'default-form-popup__input'];

        if (field.classModifier) {
            classes.push(`default-form-popup__input--${field.classModifier}`);
        }

        if (field.classes && Array.isArray(field.classes)) {
            classes = classes.concat(field.classes);
        }

        return `
            <div class="form-group">
                <input type="${type}"
                    class="${classes.join(' ')}"
                    name="${code}"
                    placeholder="${label}"
                    ${field.required ? 'required' : ''}
                />
            </div>
        `;
    }

    onSubmit(e) {
        e.preventDefault();

        switch (this.state) {
            case 'sent':
                this.$popup.modal('hide');
                //this.$popup.remove();
                //delete this;

                break;

            case 'fill':
            default:
                let formData = {
                    ajax: 'Y',
                    formId: 'form_popup',
                    formSubId: this.data.formId,
                    sessid: app.sessid
                };

                this.$popup.find('input, select').each((index, el) => {
                    if (!$(el).attr('name')) {
                        return;
                    }

                    formData[$(el).attr('name')] = $(el).val();
                });

                formData._protect = this.$popup.find('input[name="_key"]').val().substr(3);

                $.ajax({
                    url: '/local/public/default_form_popup.php',
                    dataType: 'json',
                    method: 'post',
                    data: formData,
                }).done((response) => {
                    if (response.status == 'error') {
                        let errors = '';

                        if (response.error) {
                            errors = response.error;
                        } else {
                            for (let i = 0; i < response.errors.length; i++) {
                                errors += response.errors[i].text + '\n';
                            }
                        }

                        alert(errors);
                        return;
                    }

                    this.$popup.find(`.default-form-popup__success`).removeClass('hidden');
                    this.$popup.find(`.default-form-popup__submit`).text('Закрыть');
                    this.state = 'sent';
                });

                break;
        }
    }

    onSubmitClick() {
        this.$popup.find('form').submit();
    }

    onClose() {
        this.$popup.modal('dispose');
        this.$popup.remove();
        delete this;
    }

    toggleSubmit(e) {
        const $button = this.$popup.find(`.default-form-popup__submit`);
        $button.prop('disabled', !$(e.currentTarget).prop('checked'));
        $button.toggleClass('gui-button--disabled', !$(e.currentTarget).prop('checked'));
    }
}
